/**
 * @generated SignedSource<<8f4a6edda79690d1a70d9758a8851d97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VisibilityTreeConfigType = "VisibilityTree_AfterDateTime" | "VisibilityTree_Hide" | "VisibilityTree_NotAfterDateTime" | "VisibilityTree_OnlyAZAVAccount" | "VisibilityTree_OnlyAdmins" | "VisibilityTree_OnlyBusinessAccount" | "VisibilityTree_OnlyEditors" | "VisibilityTree_OnlyIfTreeState" | "VisibilityTree_OnlyPermissionsImpl" | "VisibilityTree_OnlyWithLicense";
import { FragmentRefs } from "relay-runtime";
export type NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment$data = {
  readonly configType: VisibilityTreeConfigType;
  readonly dateTime: string;
  readonly id: string;
  readonly " $fragmentType": "NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment";
};
export type NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment$key = {
  readonly " $data"?: NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configType",
      "storageKey": null
    }
  ],
  "type": "NotAfterDateTimeVisibilityTreeConfig",
  "abstractKey": null
};

(node as any).hash = "d944e48e07cc84cd6d2cca97c4d5efb2";

export default node;
